export class Remark {
    remarkId: number;
    remark: string;
}
